import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { isAdminOrSuperUser } from '../utils/RoleUtils';

/**
 * Solo admin/super puede abrir el flujo de alta de OC (`/ordenes-compra/nueva`).
 * `permissionGuard` puede conceder `/ordenes-compra` por permisos modulares sin rol amplio.
 */
export const purchaseOrderCreateGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (!environment.token) {
    void router.navigate(['/login']);
    return false;
  }
  if (isAdminOrSuperUser()) {
    return true;
  }
  void router.navigate(['/ordenes-compra']);
  return false;
};
